import { useEffect, useState, useCallback } from 'react';

import { isBrowser } from '@lucid/utils';

type UseURLParamsKeys = 's' | 'page' | 'p' | 'f';

const useURLParams = (paramKey: UseURLParamsKeys) => {
  const searchParams = isBrowser() ? window.location.search : '';

  const [paramValue, setParamValue] = useState(() => {
    const urlParams = new URLSearchParams(searchParams);

    return urlParams.get(paramKey) || '';
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(searchParams);
    const urlParamValue = urlParams.get(paramKey) || '';

    if (urlParamValue !== paramValue) {
      setParamValue(urlParamValue);
    }
  }, [searchParams, paramKey, paramValue]);

  const updateURLParam = useCallback(
    (newValue: string) => {
      if (!isBrowser()) return;
      const url = new URL(window.location.href);

      if (newValue === '') {
        url.searchParams.delete(paramKey);
      } else {
        url.searchParams.set(paramKey, newValue);
      }
      window.history.replaceState({ path: url.href }, '', url.href);
    },
    [paramKey],
  );

  return {
    paramValue,
    updateURLParam,
  };
};

export default useURLParams;
